import { useState, useEffect } from 'react';

const CACHE_TTL_MS = 60 * 60 * 1000; // 1 hour
const CACHE_KEY = 'exchange_rate_usd';

export const useExchangeRate = () => {
  const [dollarRate, setDollarRate] = useState(4.12);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchExchangeRate = async () => {
      // Check localStorage cache
      try {
        const cached = localStorage.getItem(CACHE_KEY);
        if (cached) {
          const { timestamp, rate } = JSON.parse(cached);
          if (Date.now() - timestamp < CACHE_TTL_MS) {
            setDollarRate(rate);
            return;
          }
        }
      } catch {
        // ignore corrupt cache
      }

      setIsLoading(true);
      try {
        const response = await fetch('https://api.nbp.pl/api/exchangerates/rates/a/usd/');
        if (!response.ok) {
          throw new Error('Failed to fetch exchange rate');
        }
        const data = await response.json();
        const rate = data.rates[0].mid;

        try {
          localStorage.setItem(CACHE_KEY, JSON.stringify({ timestamp: Date.now(), rate }));
        } catch {
          // ignore storage errors
        }

        setDollarRate(rate);
      } catch (error) {
        console.error('Error fetching exchange rate:', error);
        setDollarRate(4.12);
      } finally {
        setIsLoading(false);
      }
    };

    fetchExchangeRate();
  }, []);

  return { dollarRate, isLoading };
};

export default useExchangeRate;
